import type { PlatformResponse } from "src/app/interfaces/webservices-interface";

// authentication.service

// authenticated request
interface IAuthenticatedRequestData {
  customer_id: number;
  session_token: string;
}

// api:login
export interface ILoginRequestData {
  csrf: string;
  username: string;
  password: string;
  clientapp: string;
  device_id?: string;
  deviceDetails?: string
  externalSource?: string;
  advertiseId?:string;
}

export enum LoginResponseComments {
  CUSTOMER_MFA_REQUIRED = "CUSTOMER_MFA_REQUIRED",
}

export interface ILoginResponsePayload {
  sessionToken: string;
  customerId: string | number;
  comments?: string | LoginResponseComments; // "CUSTOMER_MFA_REQUIRED"
  lastIPAddress: string; // "10.25.5.1",
  lastLogoutReason: string; // "LOGOUT",
  deviceId: string;
  hasNotUpdatedToc?: boolean;
  hasNotUpdatedPrivacyPolicy?: boolean;
  hasNotUpdatedHouseRules?: boolean;
  hasExceededDepositLimit?: boolean;
  reconfirmPersonalDetails?: boolean;
  strongAuthenticationRequired?: boolean;
  forcePasswordReset?: boolean;
  hasNotW2gEletronicMailConsent?:boolean;
}

export type ILoginResponse = PlatformResponse<ILoginResponsePayload>;

// api:authentication/validate-login-code
export interface IValidateLoginCodeRequestData {
  customerId: number;
  deviceId?: string;
  pinNumber: string;
  target?: string;
}

export interface IValidatePasswordResetCodeRequestData {
  customerId: number;
  pinNumber: string;
  resetPasswordToken: string;
}

export interface IValidateLoginCodeRequestObj extends IAuthenticatedRequestData {
  deviceId?: string;
  mfa?: boolean;
  pin?: string;
  target?: string;
}

export interface IValidatePasswordResetCodeRequestObj extends IAuthenticatedRequestData {
  pin?: string;
  resetPasswordToken: string;
}

export type IValidateLoginCodeResponse = PlatformResponse<void>;

// send-login-code
export interface ISendLoginCodeRequestObj extends IAuthenticatedRequestData {
  channel: string
  phone_number?: string;
}

// update-account
export interface IUpdateAccountRequestObj extends IAuthenticatedRequestData {
  phoneNumber?: string;
  // to do: add more
}

// validate-dob
export interface IValidateDobRequestObj {
  session_token: string;
  birthDate: Date;
}
